module.exports = __webpack_public_path__ + "static/media/CircularStd-Medium.4fcdd97f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CircularStd-Medium.otf
// module id = 728
// module chunks = 0